import { AUTH_ROUTE_NAME } from '@/libs/route-name';

export const profileRoute = () => {
  return {
    name: AUTH_ROUTE_NAME.PROFILE,
    path: 'account/profile',
    component: () => import('@/pages/auth/profile.vue'),
    meta: { requiresAuth: true }
  };
};

